import React from 'react';
import PropTypes from 'prop-types';

import {
  EDUCATION_SCHOOL,
  EDUCATION_DEGREE,
  EDUCATION_MAJOR,
  CURRENT,
  START_DATE,
  END_DATE,
  DESCRIPTION,
} from '@zr/utilities/profileFields';

import formikPropTypes from '@zr/components/Fields/Formik/formikPropTypes';

import SchoolField from '@zr/components/Fields/Formik/SchoolField';
import DegreeField from '@zr/components/Fields/Formik/DegreeField';
import MajorField from '@zr/components/Fields/Formik/MajorField';
import CurrentlyInProgressField from '@zr/components/Fields/Formik/CurrentlyInProgressField';
import StartYearField from '@zr/components/Fields/Formik/StartYearField';
import EndYearField from '@zr/components/Fields/Formik/EndYearField';
import DescriptionField from '@zr/components/Fields/Formik/DescriptionField';

export function EducationFields({
  formikProps, enableRichText,
}) {
  const { setValues, values } = formikProps;

  const handleCurrentChange = () => {
    // clear out end date values if current was changed
    // this also prevents submitting any previously filled values before changing current
    setValues({
      ...values,
      [END_DATE]: '',
    });
  };

  const currentlyInProgress = values[CURRENT];

  return (
    <>
      <SchoolField
        name={EDUCATION_SCHOOL}
        formikProps={formikProps}
      />
      <DegreeField
        name={EDUCATION_DEGREE}
        formikProps={formikProps}
      />
      <MajorField
        name={EDUCATION_MAJOR}
        formikProps={formikProps}
      />
      <CurrentlyInProgressField
        name={CURRENT}
        onChange={handleCurrentChange}
        formikProps={formikProps}
      />
      <div className="date_fields">
        <StartYearField
          name={START_DATE}
          formikProps={formikProps}
        />
        <EndYearField
          disabled={currentlyInProgress}
          name={END_DATE}
          placeholder={currentlyInProgress ? 'In Progress' : null}
          formikProps={formikProps}
        />
      </div>
      <DescriptionField
        name={DESCRIPTION}
        formikProps={formikProps}
        enableRichText={enableRichText}
      />
    </>
  );
}

EducationFields.propTypes = {
  formikProps: formikPropTypes.isRequired,
  enableRichText: PropTypes.bool,
};

EducationFields.defaultProps = {
  enableRichText: false,
};

export default EducationFields;
